"use strict";
/** @module models */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullSiteSurvey = exports.SiteSurveyValueFile = exports.SiteSurveyValueLink = exports.SiteSurveyValueText = exports.SiteSurveyValueType = exports.SiteSurveyValue = exports.Address = exports.SearchResultSiteSurvey = exports.MinimalSiteSurvey = void 0;
var cerealParse_1 = require("../cerealParse");
var agency_1 = require("./agency");
var MinimalSiteSurvey = /** @class */ (function () {
    function MinimalSiteSurvey(id, agency, critical, address, location) {
        this.id = id;
        this.agency = agency;
        this.critical = critical;
        this.address = address;
        this.location = location;
    }
    MinimalSiteSurvey.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new MinimalSiteSurvey(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getSubobject(o, 'agency', agency_1.MinimalAgency.parse), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'critical', SiteSurveyValue.parse), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'address', Address.parse), o['location']));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid MinimalSiteSurvey Model: ".concat(e.message));
        }
    };
    return MinimalSiteSurvey;
}());
exports.MinimalSiteSurvey = MinimalSiteSurvey;
var SearchResultSiteSurvey = /** @class */ (function () {
    function SearchResultSiteSurvey(id, address, location) {
        this.id = id;
        this.address = address;
        this.location = location;
    }
    SearchResultSiteSurvey.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SearchResultSiteSurvey(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'address', Address.parse), o['location']));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid MinimalSiteSurvey Model: ".concat(e.message));
        }
    };
    return SearchResultSiteSurvey;
}());
exports.SearchResultSiteSurvey = SearchResultSiteSurvey;
var Address = /** @class */ (function () {
    function Address(category, city, cityDistrict, country, countryRegion, entrance, full, house, houseNumber, island, level, near, poBox, postcode, road, staircase, state, stateDistrict, suburb, unit, worldRegion) {
        this.category = category;
        this.city = city;
        this.cityDistrict = cityDistrict;
        this.country = country;
        this.countryRegion = countryRegion;
        this.entrance = entrance;
        this.full = full;
        this.house = house;
        this.houseNumber = houseNumber;
        this.island = island;
        this.level = level;
        this.near = near;
        this.poBox = poBox;
        this.postcode = postcode;
        this.road = road;
        this.staircase = staircase;
        this.state = state;
        this.stateDistrict = stateDistrict;
        this.suburb = suburb;
        this.unit = unit;
        this.worldRegion = worldRegion;
    }
    Address.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new Address(cerealParse_1.ParseUtils.getStringOrNull(o, 'category'), cerealParse_1.ParseUtils.getStringOrNull(o, 'city'), cerealParse_1.ParseUtils.getStringOrNull(o, 'cityDistrict'), cerealParse_1.ParseUtils.getStringOrNull(o, 'country'), cerealParse_1.ParseUtils.getStringOrNull(o, 'countryRegion'), cerealParse_1.ParseUtils.getStringOrNull(o, 'entrance'), cerealParse_1.ParseUtils.getString(o, 'full'), cerealParse_1.ParseUtils.getStringOrNull(o, 'house'), cerealParse_1.ParseUtils.getStringOrNull(o, 'houseNumber'), cerealParse_1.ParseUtils.getStringOrNull(o, 'island'), cerealParse_1.ParseUtils.getStringOrNull(o, 'level'), cerealParse_1.ParseUtils.getStringOrNull(o, 'near'), cerealParse_1.ParseUtils.getStringOrNull(o, 'poBox'), cerealParse_1.ParseUtils.getStringOrNull(o, 'postcode'), cerealParse_1.ParseUtils.getStringOrNull(o, 'road'), cerealParse_1.ParseUtils.getStringOrNull(o, 'staircase'), cerealParse_1.ParseUtils.getStringOrNull(o, 'state'), cerealParse_1.ParseUtils.getStringOrNull(o, 'stateDistrict'), cerealParse_1.ParseUtils.getStringOrNull(o, 'suburb'), cerealParse_1.ParseUtils.getStringOrNull(o, 'unit'), cerealParse_1.ParseUtils.getStringOrNull(o, 'worldRegion')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid Address Model: ".concat(e.message));
        }
    };
    return Address;
}());
exports.Address = Address;
var SiteSurveyValue = /** @class */ (function () {
    function SiteSurveyValue(id, type, key, text, expirationTs) {
        this.id = id;
        this.type = type;
        this.key = key;
        this.text = text;
        this.expirationTs = expirationTs;
    }
    SiteSurveyValue.parse = function (o) {
        try {
            var type = cerealParse_1.ParseUtils.getEnum(o, 'type', SiteSurveyValueType);
            switch (type) {
                case SiteSurveyValueType.text:
                    return SiteSurveyValueText.parse(o);
                case SiteSurveyValueType.link:
                    return SiteSurveyValueLink.parse(o);
                case SiteSurveyValueType.file:
                    return SiteSurveyValueFile.parse(o);
                default:
                    return cerealParse_1.ParseUtils.parseFailure("Invalid SiteSurveyValue Model: Unhandled trigger '".concat(SiteSurveyValue[type], "'"));
            }
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SiteSurveyValue Model: ".concat(e.message));
        }
    };
    return SiteSurveyValue;
}());
exports.SiteSurveyValue = SiteSurveyValue;
var SiteSurveyValueType;
(function (SiteSurveyValueType) {
    SiteSurveyValueType["text"] = "text";
    SiteSurveyValueType["link"] = "link";
    SiteSurveyValueType["file"] = "file";
})(SiteSurveyValueType || (exports.SiteSurveyValueType = SiteSurveyValueType = {}));
var SiteSurveyValueText = /** @class */ (function (_super) {
    __extends(SiteSurveyValueText, _super);
    function SiteSurveyValueText(text, type, key, id, expirationTs) {
        var _this = _super.call(this, id, type, key, text, expirationTs) || this;
        _this.text = text;
        _this.type = type;
        _this.key = key;
        _this.id = id;
        _this.expirationTs = expirationTs;
        return _this;
    }
    SiteSurveyValueText.prototype.toJson = function () {
        return {
            id: this.id,
            text: this.text,
            type: SiteSurveyValueType[this.type],
            expirationTs: this.expirationTs ? this.expirationTs.toISOString() : null,
            key: this.key
        };
    };
    SiteSurveyValueText.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SiteSurveyValueText(cerealParse_1.ParseUtils.getString(o, 'text'), cerealParse_1.ParseUtils.getEnum(o, 'type', SiteSurveyValueType), cerealParse_1.ParseUtils.getString(o, 'key'), cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getUNIXTimestampDateOrNull(o, 'expirationTs')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SiteSurveyValue Model: ".concat(e.message));
        }
    };
    return SiteSurveyValueText;
}(SiteSurveyValue));
exports.SiteSurveyValueText = SiteSurveyValueText;
var SiteSurveyValueLink = /** @class */ (function (_super) {
    __extends(SiteSurveyValueLink, _super);
    function SiteSurveyValueLink(text, url, type, key, id, expirationTs) {
        var _this = _super.call(this, id, type, key, text, expirationTs) || this;
        _this.text = text;
        _this.url = url;
        _this.type = type;
        _this.key = key;
        _this.id = id;
        _this.expirationTs = expirationTs;
        return _this;
    }
    SiteSurveyValueLink.prototype.toJson = function () {
        return {
            id: this.id,
            url: this.url,
            text: this.text,
            type: SiteSurveyValueType[this.type],
            expirationTs: this.expirationTs ? this.expirationTs.toISOString() : null,
            key: this.key
        };
    };
    SiteSurveyValueLink.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SiteSurveyValueLink(cerealParse_1.ParseUtils.getString(o, 'text'), cerealParse_1.ParseUtils.getString(o, 'url'), cerealParse_1.ParseUtils.getEnum(o, 'type', SiteSurveyValueType), cerealParse_1.ParseUtils.getString(o, 'key'), cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getUNIXTimestampDateOrNull(o, 'expirationTs')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SiteSurveyValueLink Model: ".concat(e.message));
        }
    };
    return SiteSurveyValueLink;
}(SiteSurveyValue));
exports.SiteSurveyValueLink = SiteSurveyValueLink;
var SiteSurveyValueFile = /** @class */ (function (_super) {
    __extends(SiteSurveyValueFile, _super);
    function SiteSurveyValueFile(text, fileId, type, key, id, expirationTs) {
        var _this = _super.call(this, id, type, key, text, expirationTs) || this;
        _this.text = text;
        _this.fileId = fileId;
        _this.type = type;
        _this.key = key;
        _this.id = id;
        _this.expirationTs = expirationTs;
        return _this;
    }
    SiteSurveyValueFile.prototype.toJson = function () {
        return {
            id: this.id,
            fileId: this.fileId,
            text: this.text,
            type: SiteSurveyValueType[this.type],
            expirationTs: this.expirationTs ? this.expirationTs.toISOString() : null,
            key: this.key
        };
    };
    SiteSurveyValueFile.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SiteSurveyValueFile(cerealParse_1.ParseUtils.getString(o, 'text'), cerealParse_1.ParseUtils.getString(o, 'fileId'), cerealParse_1.ParseUtils.getEnum(o, 'type', SiteSurveyValueType), cerealParse_1.ParseUtils.getString(o, 'key'), cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getUNIXTimestampDateOrNull(o, 'expirationTs')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SiteSurveyValue Model: ".concat(e.message));
        }
    };
    return SiteSurveyValueFile;
}(SiteSurveyValue));
exports.SiteSurveyValueFile = SiteSurveyValueFile;
var FullSiteSurvey = /** @class */ (function () {
    function FullSiteSurvey(id, agency, critical, address, location, advisories, informationals, expirationTs) {
        this.id = id;
        this.agency = agency;
        this.critical = critical;
        this.address = address;
        this.location = location;
        this.advisories = advisories;
        this.informationals = informationals;
        this.expirationTs = expirationTs;
    }
    FullSiteSurvey.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new FullSiteSurvey(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getSubobject(o, 'agency', agency_1.MinimalAgency.parse), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'critical', SiteSurveyValue.parse), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'address', Address.parse), o['location'], cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'advisories', SiteSurveyValue.parse, 'throw'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'informationals', SiteSurveyValue.parse, 'throw'), cerealParse_1.ParseUtils.getUNIXTimestampDateOrNull(o, 'expirationTs')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid FullSiteSurvey Model: ".concat(e.message));
        }
    };
    return FullSiteSurvey;
}());
exports.FullSiteSurvey = FullSiteSurvey;
//# sourceMappingURL=siteSurvey.js.map